import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { DepositService } from '../../../service/deposit.service';
import { OptionListService } from '../../../service/optionList.service';
import { ResizeService } from '../../../service/resize.service';
import { UserDataService } from '../../../service/userDataService';

@Component({
    selector: 'app-deposit-declined',
    standalone: true,
    imports: [CommonModule, TranslateModule],
    templateUrl: './deposit-declined.component.html',
    styleUrl: './deposit-declined.component.scss',
})
export class DepositDeclinedComponent implements OnInit {
    failureResponse: any;
    isMobile: boolean;
    btnData: any;
    constructor(
        public userDataService: UserDataService,
        private depositService: DepositService,
        private optionListService: OptionListService,
        private resizeService: ResizeService,
    ) {
        this.resizeService.resizeCashier();
    }
    ngOnInit(): void {
        this.failureResponse = this.depositService.submitResponse;
        const { activeRegisteredbankAccounts, bank_registration_allowed_count } = this.userDataService.userData.configParams;
        this.btnData =
            activeRegisteredbankAccounts < bank_registration_allowed_count
                ? {
                      content: 'PARTY.CASHIER.web.deposit.failure.managebankaccounts.registerbankaccount.btn',
                      type: 'bank-account-register&br_showRegisterForm=true',
                  }
                : { content: 'PARTY.CASHIER.web.deposit.bankregistration.managebank.button', type: 'manage-bank-accounts' };
    }
    redirectToMainCashier() {
        const typeParam = '&type=' + this.btnData?.type;
        this.optionListService.redirectToMainCashier(typeParam);
    }
    goBackToDeposit() {
        this.depositService.showDepositInput.set(true);
        this.depositService.showDeclinePage.set(false);
        setTimeout(() => {
            this.resizeService.resizeCashier();
        }, 500);
    }
}
